import { useTheme, Alert, IconButton, Menu, MenuItem, Button } from "@mui/material";
import { MoreHoriz } from "@mui/icons-material";
import { useEffect, useRef, useState } from "react";
import {
  MenuButtonAddTable,
  MenuButtonBlockquote,
  MenuButtonBold,
  MenuButtonBulletedList,
  MenuButtonCode,
  MenuButtonCodeBlock,
  MenuButtonEditLink,
  MenuButtonHighlightColor,
  MenuButtonHorizontalRule,
  MenuButtonImageUpload,
  MenuButtonIndent,
  MenuButtonItalic,
  MenuButtonOrderedList,
  MenuButtonRedo,
  MenuButtonRemoveFormatting,
  MenuButtonStrikethrough,
  MenuButtonSubscript,
  MenuButtonSuperscript,
  MenuButtonTextColor,
  MenuButtonUnderline,
  MenuButtonUndo,
  MenuButtonUnindent,
  MenuControlsContainer,
  MenuDivider,
  MenuSelectFontFamily,
  MenuSelectFontSize,
  MenuSelectHeading,
  MenuSelectTextAlign,
  isTouchDevice,
} from "mui-tiptap";



import { useDispatch, useSelector } from "react-redux";
import { getUploadKeyAction, setUploadFileAction } from "../../../../store/reducers/mmymSlice";

interface PlaceholderValue {
  placeholder: string;
  label: string;
}
interface EditorMenuControlsProps {
  editor: any; // Replace "any" with the correct editor type if available
  placeholders: PlaceholderValue[] | null;
  hideFontControls?: boolean;
}

// New component for inserting placeholders – now receiving the editor via props
function EstimateEditMenu({ editor, placeholderValues }: { editor: any; placeholderValues: PlaceholderValue[] | null }) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  console.log("placeholderValues-53", placeholderValues);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    // Only open the menu if the editor instance is available.
    if (!editor) return;
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleInsertPlaceholder = (placeholder: string) => {
    if (!editor) return; // Guard against undefined editor
    editor.commands.insertContent(`{{${placeholder}}}`);
    handleClose();
  };

  return (
    <>
  
        {/* {placeholderValues && placeholderValues.map(({ placeholder, label }: PlaceholderValue) => (
          <Button
          variant="outlined"
          size="small"
            key={placeholder}
            onClick={() => handleInsertPlaceholder(placeholder)}
          >
            {label}
          </Button>
        ))} */}
        {
          placeholderValues && placeholderValues.map((item: any) => {
  const placeholder = typeof item === "string" ? item : item.placeholder;
  const label = typeof item === "string" ? item : item.label;

  return (
    <Button
      variant="outlined"
      size="small"
      key={placeholder}
      onClick={() => handleInsertPlaceholder(placeholder)}
    >
      {label}
    </Button>
  );
})
        }
    </>
  );
}

export default function EditorMenuControls({
  editor,
  placeholders,
  hideFontControls = false,
}: EditorMenuControlsProps) {
  const theme = useTheme();
  const [imageError, setImageError] = useState("");
  const dispatch = useDispatch();
  const { publicUrl } = useSelector((state: any) => state?.mmym);
  console.log("placeholders -92", placeholders);
  // Use a ref to keep track of the most recent publicUrl
  const publicUrlRef = useRef(publicUrl);
  useEffect(() => {
    publicUrlRef.current = publicUrl;
  }, [publicUrl]);

  const handleImageUpload = async (files:any) => {
    const file = files[0];
    if (!file || !file.type.includes("image/")) {
      setImageError(`You selected a non-image file (${file?.type}). Please select an image.`);
      setTimeout(() => setImageError(""), 3000);
      return [];
    }
    if (file.size > 5000000) {
      const size = (file.size / 1000).toFixed(0);
      setImageError(`Filesize ${size} kb is too big. Maximum allowed is 5000 kb.`);
      setTimeout(() => setImageError(""), 3000);
      return [];
    }

    try {
      // Read file as a data URL
      const imageDataUrl = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });

      // Dispatch action to get the upload key (if needed)
      if (file.name) {
        await dispatch(
          getUploadKeyAction({
            fileName: `/editor/${file.name}`,
            fileType: file.type,
            keepPublic: true,
            body: file,
            page: "editor",
          })
        );
      }

      // Dispatch action to set/upload the file
      await dispatch(
        setUploadFileAction({
          url: imageDataUrl,
          key: "",
        })
      );

      // Poll for the updated publicUrl (max 10 attempts)
      let attempts = 0;
      const maxAttempts = 10;
      while (!publicUrlRef.current && attempts < maxAttempts) {
        await new Promise((resolve) => setTimeout(resolve, 300));
        attempts++;
      }

      if (publicUrlRef.current) {
        // Once the publicUrl is updated, return the image info to add at the cursor.
        return [
          {
            src: publicUrlRef.current,
            alt: file.name,
          },
        ];
      } else {
        setImageError("Image upload failed. Please try again.");
        return [];
      }
    } catch (error) {
      setImageError("Image upload failed. Please try again.");
      return [];
    }
  };

  return (
    <MenuControlsContainer>
      <MenuSelectFontFamily
        options={[
          { label: "Comic Sans", value: "Comic Sans MS, Comic Sans" },
          { label: "Cursive", value: "cursive" },
          { label: "Monospace", value: "monospace" },
          { label: "Serif", value: "serif" },
        ]}
      />

      <MenuDivider />

      <MenuSelectHeading />

      <MenuDivider />

      <MenuSelectFontSize />

      <MenuDivider />

      <MenuButtonBold />
      <MenuButtonItalic />
      <MenuButtonUnderline />
      <MenuButtonStrikethrough />
      <MenuButtonSubscript />
      <MenuButtonSuperscript />

      <MenuDivider />

      <MenuButtonTextColor
        defaultTextColor={theme.palette.text.primary}
        swatchColors={[
          { value: "#000000", label: "Black" },
          { value: "#ffffff", label: "White" },
          { value: "#888888", label: "Grey" },
          { value: "#ff0000", label: "Red" },
          { value: "#ff9900", label: "Orange" },
          { value: "#ffff00", label: "Yellow" },
          { value: "#00d000", label: "Green" },
          { value: "#0000ff", label: "Blue" },
        ]}
      />

      <MenuButtonHighlightColor
        swatchColors={[
          { value: "#595959", label: "Dark grey" },
          { value: "#dddddd", label: "Light grey" },
          { value: "#ffa6a6", label: "Light red" },
          { value: "#ffd699", label: "Light orange" },
          { value: "#ffff00", label: "Yellow" },
          { value: "#99cc99", label: "Light green" },
          { value: "#90c6ff", label: "Light blue" },
          { value: "#8085e9", label: "Light purple" },
        ]}
      />

      <MenuDivider />

      <MenuButtonEditLink />

      <MenuDivider />

      <MenuSelectTextAlign />

      <MenuDivider />

      <MenuButtonOrderedList />
      <MenuButtonBulletedList />

      {isTouchDevice() && (
        <>
          <MenuButtonIndent />
          <MenuButtonUnindent />
        </>
      )}

      <MenuDivider />

      <MenuButtonBlockquote />

      <MenuDivider />

      <MenuButtonCode />
      <MenuButtonCodeBlock />

      <MenuDivider />

      <MenuButtonImageUpload onUploadFiles={handleImageUpload} />

      <MenuDivider />

      <MenuButtonHorizontalRule />
      <MenuButtonAddTable />

      <MenuDivider />

      <MenuButtonRemoveFormatting />

      <MenuDivider />

      <MenuButtonUndo />
      <MenuButtonRedo />
        <MenuDivider />
      <EstimateEditMenu editor={editor} placeholderValues={placeholders} />

      {imageError && (
        <Alert severity="error" style={{ marginTop: theme.spacing(1) }}>
          {imageError}
        </Alert>
      )}
    </MenuControlsContainer>
  );
}
